import { motion } from 'framer-motion';
import { forwardRef } from 'react';

interface OverlayProps {
  onClose: () => void;
  className?: string;
}

export const Overlay = forwardRef<HTMLDivElement, OverlayProps>(
  ({ onClose, className = 'absolute inset-0 z-45' }, ref) => {
    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.4 }}
        exit={{ opacity: 0, pointerEvents: 'none' }}
        transition={{ duration: 0.2 }}
        onClick={onClose}
        className={className}
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
      />
    );
  },
);
Overlay.displayName = 'Overlay';
